var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowPwrd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.436,
    height: 13.709,
    viewBox: "0 0 21.436 13.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-svgrepo-com",
    transform: "translate(0.933 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29327",
    "data-name": "Path 29327",
    d: "M15.58,12A3.58,3.58,0,1,1,12,8.42,3.576,3.576,0,0,1,15.58,12Z",
    transform: "translate(-2.215 -5.892)",
    fill: "none",
    stroke: "#5b5b5b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29328",
    "data-name": "Path 29328",
    d: "M12,15.93a11.985,11.985,0,0,0,9.11-4.191,3.053,3.053,0,0,0,0-3.829,12,12,0,0,0-18.22,0,3.053,3.053,0,0,0,0,3.829A11.985,11.985,0,0,0,12,15.93Z",
    transform: "translate(-2.215 -3.72)",
    fill: "none",
    stroke: "#989898",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPwrd);
export default __webpack_public_path__ + "static/media/showPwrd.c9b5ee1861cf8b5f29720364f1c2ea73.svg";
export { ForwardRef as ReactComponent };